import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { CostReceiverCreateDto, CostReceiverDto, CostReceiverExcelDownloadDto, CostReceiverUpdateDto, GetCostReceiversInputDto } from '../dtos/cost-receiver/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class CostReceiverService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: CostReceiverCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CostReceiverDto>({
      method: 'POST',
      url: '/api/controlling/costReceivers',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/costReceivers/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/costReceivers',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CostReceiverDto>({
      method: 'GET',
      url: `/api/controlling/costReceivers/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/costReceivers/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCostReceiversInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CostReceiverDto>>({
      method: 'GET',
      url: '/api/controlling/costReceivers',
      params: { name: input.name, costReceiverTypeId: input.costReceiverTypeId, costReceiverTypeName: input.costReceiverTypeName, entityId: input.entityId, isActive: input.isActive, cycle: input.cycle, cycleFrom: input.cycleFrom, cycleTo: input.cycleTo, cycleRotation: input.cycleRotation, cycleRotationFrom: input.cycleRotationFrom, cycleRotationTo: input.cycleRotationTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: CostReceiverExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/costReceivers/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, costReceiverTypeId: input.costReceiverTypeId, costReceiverTypeName: input.costReceiverTypeName, entityId: input.entityId, isActive: input.isActive, cycle: input.cycle, cycleFrom: input.cycleFrom, cycleTo: input.cycleTo, cycleRotation: input.cycleRotation, cycleRotationFrom: input.cycleRotationFrom, cycleRotationTo: input.cycleRotationTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CostReceiverDto[]>({
      method: 'GET',
      url: '/api/controlling/costReceivers/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: CostReceiverUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CostReceiverDto>({
      method: 'PUT',
      url: `/api/controlling/costReceivers/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}